import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=a86cc778&scoped=true&"
import script from "./fans.vue?vue&type=script&lang=js&"
export * from "./fans.vue?vue&type=script&lang=js&"
import style0 from "./fans.vue?vue&type=style&index=0&id=a86cc778&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86cc778",
  null
  
)

export default component.exports